<template>
  <div class="max-w-xl rounded overflow-hidden shadow-lg text-white" :class="isError ? 'bg-red-700' : 'bg-gray-700'">
    <div class="px-16 py-14">
      <div class="font-bold text-xl mb-2">{{ label }}</div>
      <p class="text-white text-base">
        <slot></slot>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    isError: {
      type: Boolean,
      default: false
    }
  },
  name: "WelcomePane"
}
</script>